import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import './assets/style/im.scss';
import './assets/iconfont/iconfont.css';
import './assets/style/roo-renderer-adapter.css';

// 🔥 生产环境禁用 console.log/warn/info/debug，保留 error
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.log('[Main] 生产环境日志已禁用');
}

import httpRequest from './api/httpRequest';
import * as socketApi from './api/wssocket';
import * as messageType from './api/messageType';
import emotion from './api/emotion.js';
import url from './api/url.js';
import element from './api/element.js';
import store from './store';
import * as  enums from './api/enums.js';
import * as  date from './api/date.js';
import './utils/directive/dialogDrag';
import { checkVersionAndCleanup } from './utils/versionCheck';

// 🔥 版本检测和缓存清理（必须在最前面执行）
checkVersionAndCleanup();

Vue.use(ElementUI);
// 挂载全局
Vue.prototype.$wsApi = socketApi;
Vue.prototype.$msgType = messageType
Vue.prototype.$date = date;
Vue.prototype.$http = httpRequest // http请求方法
Vue.prototype.$emo = emotion; // emo表情
Vue.prototype.$url = url; // url转换
Vue.prototype.$elm = element; // 元素操作
Vue.prototype.$enums = enums; // 枚举
Vue.prototype.$eventBus = new Vue(); // 全局事件
// 添加$bus别名，确保与组件中的使用保持一致
Vue.prototype.$bus = Vue.prototype.$eventBus;
Vue.config.productionTip = false;

// 🔥 页面刷新时恢复登录状态
try {
  const savedUserInfo = localStorage.getItem('userInfo');
  const hasToken = sessionStorage.getItem('accessToken');
  
  // 只有在 sessionStorage 中有 token 时才恢复登录状态
  if (savedUserInfo && hasToken) {
    const userInfo = JSON.parse(savedUserInfo);
    if (userInfo?.accessToken === hasToken) {
      console.log('[Main] 恢复登录状态');
      // 恢复 token 到 sessionStorage
      if (userInfo.refreshToken) {
        sessionStorage.setItem('refreshToken', userInfo.refreshToken);
      }
      if (userInfo.tokenKey) {
        sessionStorage.setItem('tokenKey', userInfo.tokenKey);
      }
      // 恢复用户信息到 store
      store.commit('setUserInfo', userInfo);
      store.commit('setIsLoggedIn', true);
    }
  } else if (!hasToken) {
    // 如果没有 token，清除登录状态
    console.log('[Main] 未检测到 token，清除登录状态');
    store.commit('setIsLoggedIn', false);
    localStorage.removeItem('userInfo');
  }
} catch (error) {
  console.error('[Main] 恢复登录状态失败:', error);
  store.commit('setIsLoggedIn', false);
}

new Vue({
  el: '#app',
  // 配置路由
  router,
  store,
  render: h => h(App)
})

